// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure body has black background for matrix effect */
body, html {
  background: black !important;
  margin: 0;
  padding: 0;
  font-family: 'Fira Code', monospace;
}

#root {
  background: black;
}

/* Matrix theme enhancements */
body {
  color: #ffffff;
}

/* Ensure proper z-index layering */
.header, .footer {
  position: relative;
  z-index: 2;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.content {
  position: relative;
  z-index: 1;
}

/* Matrix-style text shadows for better readability */
h1, h2, h3, h4, h5, h6 {
  text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 30px rgba(67, 199, 15, 0.3);
}

p {
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(67, 199, 15, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,yEAAyE;AAC3E;;AAEA;EACE,yEAAyE;AAC3E","sourcesContent":["/* Ensure body has black background for matrix effect */\r\nbody, html {\r\n  background: black !important;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Fira Code', monospace;\r\n}\r\n\r\n#root {\r\n  background: black;\r\n}\r\n\r\n/* Matrix theme enhancements */\r\nbody {\r\n  color: #ffffff;\r\n}\r\n\r\n/* Ensure proper z-index layering */\r\n.header, .footer {\r\n  position: relative;\r\n  z-index: 2;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n.content {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n/* Matrix-style text shadows for better readability */\r\nh1, h2, h3, h4, h5, h6 {\r\n  text-shadow: 0 0 15px rgba(0, 0, 0, 0.9), 0 0 30px rgba(67, 199, 15, 0.3);\r\n}\r\n\r\np {\r\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.8), 0 0 20px rgba(67, 199, 15, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
